import {Stack as MuiStack} from '@mui/material';
import React from 'react';

const Stack = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof MuiStack>
>((props, ref) => {
  return <MuiStack ref={ref} {...props} />;
});

export default Stack;
